import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconPackageDelivery1: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"package-delivery-1, address"} maskId="square-filled-radius-0-stroke-1-IconPackageDelivery1"><path d="M21 3H3V21H14V20H4V4H8V10H16V4H20V11H21V3Z" fill="currentColor"/><path d="M20.7251 13.7762C19.3582 12.4079 17.1418 12.4079 15.7749 13.7762C14.4084 15.1442 14.4084 17.3619 15.7749 18.7299L18.25 21.2075L20.7251 18.7299C22.0916 17.3619 22.0916 15.1442 20.7251 13.7762Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconPackageDelivery1;
